import styled from "styled-components";

const Form = styled.div`
width:70%;
margin:auto;
background: #36312F;
border-radius: 20px;
padding:2%;
text-align:center;
color:#f3f3f3;
box-shadow: 5px 5px 5px #000;
z-index:3;
margin-top:10%;

& h1{
    color:#FBB700;
}

`;

export default Form;
